import * as React from "react";
import Svg, { G, Circle, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <G filter="url(#filter0_d_5362_30785)">
      <Circle cx={20} cy={18} r={16} fill="white" />
    </G>
    <Path
      d="M20.0031 21C19.2421 21 18.6279 20.5689 18.5546 19.9063C18.4629 19.14 18.4262 18.3577 18.3804 17.5913C18.252 15.7393 18.1145 13.8952 18.0045 12.0432C17.9586 11.2768 18.2612 10.6382 19.0496 10.2311C20.2689 9.60841 21.8458 10.3109 21.9742 11.5403C22.0567 12.3386 21.9192 13.1289 21.8733 13.9192C21.7633 15.8191 21.58 17.719 21.5249 19.619C21.4791 20.4412 20.874 21 20.0031 21Z"
      fill="black"
      fillOpacity={0.8}
    />
    <Path
      d="M21.9999 24.0606C21.9906 25.1277 21.0819 26.0092 19.9953 25.9999C18.9087 25.9906 17.9907 25.072 18.0001 23.9956C18.0094 22.9007 18.9555 21.9728 20.0515 22.0006C21.1569 22.0099 22.0093 22.91 21.9999 24.0606Z"
      fill="black"
      fillOpacity={0.8}
    />
    <Defs />
  </Svg>
);
export default SVGComponent;
